<template>
  <v-card flat>
    <v-card-title primary-title class="primary white--text">
      <h3 color="primary">FILTERS</h3>
    </v-card-title>
    <v-card-text>
      <v-expansion-panel>
        <v-expansion-panel-content
        v-for="(item,i) in filters"
        :key="i+'fil'"
        >
          <div slot="header" v-if="item.reportType.includes(reportType)"><b class="primary--text font-weight-bold">{{item.name}}</b></div>
            <v-card>
              <v-card-text v-if="item.type=='select' && item.reportType.includes(reportType)">
                <v-select
                  :items="item.options"
                  :label="item.placeholder"
                  v-model="item.model"
                ></v-select>
              </v-card-text>
              <v-card-text v-else-if="item.type=='search' && item.reportType.includes(reportType)">
                <v-autocomplete
                  :items="item.options"
                  :search-input.sync="item.input"
                  v-model="item.model"
                  class="mx-3"
                  flat
                  hide-no-data
                  hide-details
                  :label="item.placeholder"
                  solo-inverted
                  clearable
                ></v-autocomplete>
              </v-card-text>
              <v-card-text v-else-if="item.type=='number-range' && item.reportType.includes(reportType)">
                <v-slider
                  v-model="item.model"
                  thumb-label
                  :label="item.label"
                  :min="item.min"
                  :max="item.max"
                  range
                ></v-slider>
              </v-card-text>
              <v-card-text v-else-if="item.type=='date-range' && item.reportType.includes(reportType)">
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="item.menu"
                  :nudge-right="40"
                  :return-value.sync="item.start"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="item.model"
                    label="Pick a Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="item.model"
                    no-title
                    scrollable
                    @input="item.menu = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn large round primary title class="primary white--text"
        @click.native="clearFilter()"
        color="white">
        Clear Filter
      </v-btn>
    </v-card-actions>
  </v-card>
    
</template>
<script>
export default {
  props: ["reportType","units","selectedBrand","brandFinYear"],
  data () {
    return {
      filters: {
        date: {
          name: 'Date/ From Date',
          model: null,
          type: 'date-range',
          placeholder: 'Select Date',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase","stock", "productGroup"]
        },
        tillDate: {
          name: 'To Date',
          model: null,
          type: 'date-range',
          placeholder: 'Select Date',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase","stock", "productGroup"]
        },
        month: {
          name: 'Month',
          model: null,
          type: 'select',
          placeholder: 'Select Month',
          options: [{
            text: 'January',
            value: 0
          },{
            text: 'February',
            value: 1
          },{
            text: 'March',
            value: 2
          },{
            text: 'April',
            value: 3
          },{
            text: 'May',
            value: 4
          },{
            text: 'June',
            value: 5
          },{
            text: 'July',
            value: 6
          },{
            text: 'August',
            value: 7
          },{
            text: 'September',
            value: 8
          },{
            text: 'October',
            value: 9
          },{
            text: 'November',
            value: 10
          },{
            text: 'December',
            value: 11
          }],
          reportType : ["sale","purchase","stock", "productGroup"]
        },
        firms: {
          name: 'Firms',
          model: null,
          type: 'select',
          placeholder: 'Select a firm',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase", "stock", "productGroup"]
        },
        productGroups: {
          name: 'Product Group',
          model: null,
          type: 'select',
          placeholder: 'Select a Group',
          options: [{
            text: '',
            value: ''
          }],
          reportType : [ "stock"]
        },
        stockReportType: {
          name: 'Stock Report Type',
          model: 'quantity',
          type: 'select',
          placeholder: 'Select Type',
          options: [
            {
            text: 'Quantity',
            value: 'quantity'
          },{
            text: 'Weight',
            value: 'grossWeight'
          }],
          reportType : []
        },
        paymentType: {
          name: 'Payment Type',
          model: null,
          type: 'select',
          placeholder: 'Select a Item Type',
          options: [{
            text: 'Cash',
            value: 'Cash'
          }, {
            text: 'Bank Account',
            value: 'Bank Account'
          }, {
            text: 'Cash Bank Account',
            value: 'CashAndBank Account'
          }],
          reportType : ["sale","purchase"]
        },
        invoiceStatus: {
          name: 'Invoice Status Type',
          model: null,
          type: 'select',
          placeholder: 'Select Invoice Status',
          options: [{
            text: 'Due',
            value: 'due'
          }, {
            text: 'Partial',
            value: 'partial'
          },{
            text: 'Paid',
            value: 'paid'
          }],
          reportType : ["sale","purchase"]
        },
        invoiceNumber: {
          name: 'Invoice Number',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search for Invoice',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase"]
        },
        buyerName: {
          name: 'Person Name',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by Buyer name',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase","stock"]
        },
        gstPercentage: {
          name: 'GST %',
          model: null,
          type: 'select',
          placeholder: 'Select GST %',
          options: [0,5,12,18,28],
          reportType : ["sale","purchase","stock", "productGroup"]
        },
        // isActive: {
        //   name: 'Status',
        //   model: null,
        //   type: 'select',
        //   placeholder: 'Select Status',
        //   options: ["Active", "Inactive"],
        //   reportType : ["sale","purchase","stock", "productGroup"]
        // },
        gstType: {
          name: 'GST Type',
          model: null,
          type: 'select',
          placeholder: 'Select Type',
          options: ["SGST|CGST","IGST"],
          reportType : ["sale","purchase"]
        },
        gstCategory: {
          name: 'GST Category',
          model: null,
          type: 'select',
          placeholder: 'GST Category',
          options: [
                {
                  text: "Exempt",
                  value: "EXEMPT"
                },
                {
                  text: "Nil Rated",
                  value: "NILL"
                },
                {
                  text: "Taxable",
                  value: "TAXABLE"
                },
                {
                  text: "Others",
                  value: "OTHER"
                }],
                reportType : ["sale","purchase","stock", "productGroup"]
        },
        isActive: {
          name: 'Product Status',
          model: null,
          type: 'select',
          placeholder: 'Product Status',
          options: [
                {
                  text: "Active",
                  value: true
                },
                {
                  text: "Inactive",
                  value: false
                }],
                reportType : ["sale","purchase","stock", "productGroup"]
        },
        unit : {
          name: 'Units',
          model: null,
          type: 'select',
          placeholder: 'Units',
          options: this.getUnits(),
          reportType : ["sale","purchase","stock", "productGroup"]         
        },
        quantity : {
          name: 'Quantity',
          model: null,
          type: 'number-range',
          label: 'Quantity',
          min: 0,
          max: 5000,
          reportType : ["sale","purchase","stock", "productGroup"]
        },
        hsnCode: {
          name: 'HSN Code',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search for HSN code',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase","stock", "productGroup"]
        },
        duration : {
          name: 'Duration',
          model: null,
          type: 'number-range',
          label: 'Duration',
          min: 0,
          max: 200,
          reportType : ["sale","purchase"]
        },
         openingQuantity : {
          name: 'Opening Quantity',
          model: null,
          type: 'number-range',
          label: 'Opening Quantity',
          min: 0,
          max: 5000,
          reportType : ["stock", "productGroup"]
        },
         saleQuantity : {
          name: 'Sale Quantity',
          model: null,
          type: 'number-range',
          label: 'Sale Quantity',
          min: 0,
          max: 5000,
          reportType : ["stock", "productGroup"]
        },
         purchaseQuantity : {
          name: 'Purchase Quantity',
          model: null,
          type: 'number-range',
          label: 'Purchase Quantity',
          min: 0,
          max: 5000,
          reportType : ["stock", "productGroup"]
        },
        village: {
          name: 'Village',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by Village Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase"]
        },
        block: {
          name: 'Block',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by Block Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase"]
        },
        tehsil: {
          name: 'Tehsil',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by Tehsil Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase"]
        },
        district: {
          name: 'District',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by District Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase"]
        },
        state: {
          name: 'State',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by State Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType : ["sale","purchase"]
        },
      },
      firms: [],
      invoices: [],
      buyers : [],
      sellers : [],
      products : [],
      productGroups : [],
    }
  },
  created () {
    this.$bindAsArray(
      'firms',
      this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'buyers',
      this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'sellers',
      this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'invoices',
      this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear)
    ),
    this.$bindAsArray(
      'products',
      this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'productGroups',
      this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  watch: {
    firms (val) {
      val.map(firm=>{
        if(firm.defaultFirm) {
          this.filters.firms.model = firm['.key'];
          if(firm.businessType == 'Jwellery') {
            this.filters.stockReportType.model = 'weight';
          }
        }
        
      })
      this.mapFilterOptions(val, 'firms', 'name', '.key')
    },
    productGroups (val) {
      this.mapFilterOptions(val, 'productGroups', 'name', '.key')
    },
    invoices (val) {
      this.mapFilterOptions(val, 'invoiceNumber', 'invoiceId', '.key')
    },
    buyers (val) {
      this.handleBuyerSeller();
    },
    selectedBrand (val) {
      this.mapFilterOptions(this.firms, 'firms', 'name', '.key')
      this.handleBuyerSeller();
      this.mapFilterOptions(this.invoices, 'invoiceNumber', '.key', '.key')
      this.mapFilterOptions(this.products, 'hsnCode', 'HSN_code', 'HSN_code')
    },
    products (val) {
      this.mapFilterOptions(this.products, 'hsnCode', 'HSN_code', 'HSN_code')
    },
    filters: {
      handler: function (val) {
        this.$emit('update', val)
      },
      deep: true
    },
    reportType(val){
      this.handleBuyerSeller();
    }
  },

  methods: {
    mapFilterOptions (array, filterLabel, textLabel, valLabel) {    
      if (this.selectedBrand && array) {
        const result = array.filter(item => item['brand'] === this.selectedBrand).map(item => {
          return {
            text: item[textLabel],
            value: item[valLabel]
          }
        })
        this.filters[filterLabel].options = result
      }
    },
    getUnits(){
      return this.units;
    },
    mapFilterRange (filterLabel, max, min) {
    },
    clearFilter () {
      Object.keys(this.filters).forEach(key => {
        if(key != 'stockReportType' || key != 'firms') {
          this.filters[key]['model'] = null;
        }
      })
      this.$emit('resetTabs')
    },
    handleBuyerSeller() {
      switch(this.reportType) {
        case 'sale' : {
            this.filters.buyerName = {
            name: 'Buyer Name',
            model: null,
            type: 'search',
            input: null,
            placeholder: 'Search by Buyer name',
            options: [{
              text: '',
              value: ''
            }],
            reportType : ["sale","purchase","stock"]
          }
          this.filters.state.options = [{
              text: '',
              value: ''
          }];
          this.filters.district.options = [{
              text: '',
              value: ''
          }];
          this.filters.tehsil.options = [{
              text: '',
              value: ''
          }];
          this.filters.block.options = [{
              text: '',
              value: ''
          }];
          this.filters.village.options = [{
              text: '',
              value: ''
          }];
          this.mapFilterOptions(this.buyers, 'state', 'state', 'state')
          this.mapFilterOptions(this.buyers, 'district', 'district', 'district')
          this.mapFilterOptions(this.buyers, 'tehsil', 'tehsil', 'tehsil')
          this.mapFilterOptions(this.buyers, 'block', 'block', 'block')
          this.mapFilterOptions(this.buyers, 'village', 'village', 'village')
          this.mapFilterOptions(this.buyers, 'buyerName', 'name', '.key')
          break;
        }
        case 'purchase' : {
          this.filters.buyerName = {
            name: 'Seller Name',
            model: null,
            type: 'search',
            input: null,
            placeholder: 'Search by Seller name',
            options: [{
              text: '',
              value: ''
            }],
            reportType : ["sale","purchase","stock"]
          }
          this.filters.state.options = [{
              text: '',
              value: ''
          }];
          this.filters.district.options = [{
              text: '',
              value: ''
          }];
          this.filters.tehsil.options = [{
              text: '',
              value: ''
          }];
          this.filters.block.options = [{
              text: '',
              value: ''
          }];
          this.filters.village.options = [{
              text: '',
              value: ''
          }];
          this.mapFilterOptions(this.sellers, 'state', 'state', 'state')
          this.mapFilterOptions(this.sellers, 'district', 'district', 'district')
          this.mapFilterOptions(this.sellers, 'tehsil', 'tehsil', 'tehsil')
          this.mapFilterOptions(this.sellers, 'block', 'block', 'block')
          this.mapFilterOptions(this.sellers, 'village', 'village', 'village')
          this.mapFilterOptions(this.sellers, 'buyerName', 'name', '.key')
          break;
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/Filters.vue